import throttle from 'lodash/throttle'

export default ({ app }) => {
  const resizeHandler = () => {
    const isLandscape = window.innerWidth >= 480
                      && window.innerWidth <= 980
                      && window.innerHeight < 500
                      && window.matchMedia('(orientation: landscape)').matches
    const isMobile = window.innerWidth <= 767
    const fromTablet = window.innerWidth >= 768
    const fromTabletH = window.innerWidth >= 1024
    const fromDesktop = window.innerWidth >= 1440

    const media = {
      isMobile: isMobile,
      isLandscape: isLandscape,
      fromTablet: fromTablet && !isLandscape,
      fromTabletH: fromTabletH,
      fromDesktop: fromDesktop,
      width: window.innerWidth,
    }

    app.store.commit('media/setMedia', media)
  }

  resizeHandler()

  window.addEventListener('resize', throttle(resizeHandler, 800))
}
